module.exports = __webpack_public_path__ + "img/result_txt_b.26059863.png";